import { API_URL } from "./actions/action-helpers";

export const ApiUrls = {
  account: `${API_URL}/accounts`,
  clients: `${API_URL}/clients`,
  invitations: `${API_URL}/clients/invitations`,
}